export * from "./Bogotazo";
export * from "./GeneralAspects";
export * from "./TheViolence";
export * from "./NationalFront"

export const armedConflictItems = {
  "Aspectos generales": {
    path: "/sociales/conflicto-armado/aspectos-generales",
  },
  "El Bogotazo": {
    path: "/sociales/conflicto-armado/bogotazo",
  },
  "La Violencia": {
    path: "/sociales/conflicto-armado/la-violencia",
  },
  "Frente Nacional": {
    path: "/sociales/conflicto-armado/frente-nacional",
  },
};
